import { call, put } from 'redux-saga/effects';
import { CallApi } from '../api/callApi';
import { ACTIONS, APIS, STORAGE, STORE_STORAGE } from '../../_config'

export function* addExternalDataSource(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.DATASOURCE.ADD_EXTERNAL_DATASOURCE, data);
        // console.log(resp);
        if (resp.status >= 200 && resp.status < 300) {
            console.log(resp.data);
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* addInternalDataSource(action: any): any {
    try {
        const data = action.payload;

        const resp = yield call(CallApi.POST, APIS.DATASOURCE.ADD_INTERNAL_DATASOURCE, data);
        // console.log(resp);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* getDataSource(action: any): any {
    try {
        const data = action.payload;
        let params: any = {};
        if (data?.page && data?.page_size) {
            params = {
                branch_id: data.branch_id,
                page: data.page,
                page_size: data.page_size,
            };
        }
        else {
            params = { branch_id: data.branch_id };
        }
        delete params.branch_id;
        const resp = yield call(CallApi.GET, APIS.DATASOURCE.GET_DATASOURCES + data.branch_id + '/', params, true);

        if (resp.status >= 200 && resp.status < 300) {
            // console.log('resp', resp.data);
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}

